import React, { useState, useEffect } from 'react';

import { DataGrid } from '@material-ui/data-grid';
import QuickSearchToolbar from './QuickSearchToolbar.js';

function Index({ listData, columns }) {
  const [searchText, setSearchText] = useState('');
  const [tableBody, setTableBody] = useState([]);

  const escapeRegExp = (value) => {
    return value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
  };

  const requestSearch = (searchValue) => {
    setSearchText(searchValue);
    const searchRegex = new RegExp(escapeRegExp(searchValue), 'i');
    const filteredRows = listData.filter((row) => {
      return Object.keys(row).some((field) => {
        return searchRegex.test(row[field].toString());
      });
    });
    setTableBody(filteredRows);
  };

  useEffect(() => {
    setTableBody(listData);
    requestSearch(searchText);
  }, [listData]);

  return (
    <div style={{ height: 500, width: '100%' }}>
      <DataGrid
        rows={tableBody}
        components={{ Toolbar: QuickSearchToolbar }}
        // loading={false}
        // scrollbarSize={5}
        columns={columns}
        pageSize={5}
        disableColumnSelector
        disableSelectionOnClick
        disableColumnMenu
        autoPageSize
        componentsProps={{
          toolbar: {
            value: searchText,
            onChange: (event) => requestSearch(event.target.value),
            clearSearch: () => requestSearch(''),
          },
        }}
      />
    </div>
  );
}

export default Index;
